module.exports = __webpack_public_path__ + "fonts/sf-semi-bold.e6ef4ea3.otf";